import React, { useState, useEffect } from 'react';

const BookingForm = ({ entityId, onSuccess, onCancel }) => {
  const [entityConfig, setEntityConfig] = useState(null);

  const [ Time_now, setTime_now] = useState(null);
  const [ Date_now, setDate_now] = useState(null);
  const [ period_gap, setperiod_gap] = useState(null);
 
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  
  const [formData, setFormData] = useState({
    appointment_date: '',
    reserved_part: '',
    appointment_time: '',
    reservation_duration: '',
    notes: ''
  });
  
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);


  const [availableSlots, setAvailableSlots] = useState([]);
  const [durationOptions, setDurationOptions] = useState([]);

  // Fetch entity configuration
  useEffect(() => {
    const fetchEntityConfig = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/EntityPublic/${entityId}/config`
        );
        
        if (response.ok) {
          const config = await response.json();
          setEntityConfig(config);
          
          // For accept_multiple_unit = 'yes', generate duration options
          if (config.acceptMultipleUnit === 'yes') {
            const options = [];
            for (let i = 1; i <= 8; i++) {
              options.push(config.reservationUnit * i);
            }
            setDurationOptions(options);
          }
        } else {
          setError('فشل في تحميل إعدادات الجهة');
        }
      } catch (err) {
        console.error('Error fetching entity config:', err);
        setError('حدث خطأ في تحميل البيانات');
      } finally {
        setLoading(false);
      }
    };
    
    if (entityId) {
      fetchEntityConfig();
    }

    //////////////////////////////////////////
      if (!entityId) return;
  
    const fetchServices = async () => {
      try {
        const token = localStorage.getItem('CustomerTokenA');
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/Customer/Entity/${entityId}/services`,
          {
            headers: { 'Authorization': `Bearer ${token}` }
          }
        );
        if (res.ok) {
          const data = await res.json();
          console.log("Fetched services: ",data.services);
          setServices(data.services); 
          // شكل بيانات الخدمة المقترح:
          // { id, name, durationMinutes, price }
        }
      } catch (err) {
        console.error('Error fetching services', err);
      }
    };

    fetchServices();

    //////////////////////////////////////////
  }, [entityId]);

  const get_today_period_gap_before_reservation = async () => {
      try {
        const token = localStorage.getItem('CustomerTokenA');
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/appointment/entity/${entityId}/today_period_gap_before_reservation`,
            {
              headers: { 'Authorization': `Bearer ${token}` }
            } 
        );
        
        if (response.ok) {
          const data = await response.json();
          setTime_now(data.time_now);
          setDate_now(data.date_now);
          setperiod_gap(data.period_gap);
          console.log("Time_now: ",data.time_now);
          console.log("period_gap: ",data.period_gap);
          console.log("Date_now: ",data.date_now);

        }
      } catch (err) {
        console.error('Error fetching today period gap before reservation:', err);
      }
  }

  useEffect(() => {
  if (selectedServices.length === 0) {
    setFormData(prev => ({ ...prev, reservation_duration: '' }));
    return;
  }

  // حساب إجمالي الدقائق
  let totalDuration = 0;
  selectedServices.forEach(serviceId => {
    const s = services.find(x => x.id.toString() === serviceId.toString());
    if (s) totalDuration += Number(s.durationMinutes);
  });

  setFormData(prev => ({
    ...prev,
    reservation_duration: totalDuration
  }));

  console.log("selectedServices :  ",selectedServices);
  }, [selectedServices, services]);

  // Fetch available slots when date and part are selected
  useEffect(() => {
    const fetchAvailableSlots = async () => {
      if (!formData.appointment_date || !formData.reserved_part || !entityConfig) {
        setAvailableSlots([]);
        return;
      }
      
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/appointment/entity/${entityId}/available-slots?` +
          `date=${formData.appointment_date}&part=${encodeURIComponent(formData.reserved_part)}`
        );
        
        if (response.ok) {
          const data = await response.json();
          setAvailableSlots(data.availableSlots);
          console.log("Available Slots: ",data.availableSlots);

        }
      } catch (err) {
        console.error('Error fetching available slots:', err);
      }

     await get_today_period_gap_before_reservation();
    };
    
    fetchAvailableSlots();
  }, [formData.appointment_date, formData.reserved_part, entityId, entityConfig]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Reset dependent fields
    if (name === 'appointment_date' || name === 'reserved_part') {
      setFormData(prev => ({
        ...prev,
        appointment_time: '',
        reservation_duration: ''
      }));
    }
  };

  const handlePeriodSelect = (period) => {
    setFormData(prev => ({
      ...prev,
      appointment_time: period.startTime,
      reservation_duration: period.duration
    }));
  };

  const validateBooking = () => {

    console.log("appointment_date",formData.appointment_date);
    console.log("Date_now",Date_now);
    console.log("appointment_time",formData.appointment_time);

    if (formData.appointment_date===Date_now)
    {
      console.log("date is today");
      //  check time gap
      const [appHour, appMin] = formData.appointment_time.split(':').map(Number);
      const [timeHour, timeMin] = Time_now.split(':').map(Number);
      const appTotalMin = appHour * 60 + appMin;
      const timeTotalMin = timeHour * 60 + timeMin;
      const gap = appTotalMin - timeTotalMin;
      console.log("gap: ",gap);
      console.log("period_gap: ",period_gap);
      if (gap < period_gap){
        console.log("not valid time - less than period gap");
        setError(`يرجى اختيار وقت بعد ${period_gap} دقيقة من الوقت الحالي`);
        return false;
      }

    }
    else{
      console.log("date is diffferent");
    }
    // setError(' test    ');    return false;

    if (!formData.appointment_date) {
      setError('يرجى اختيار التاريخ');
      return false;
    }
    
    if (!formData.reserved_part) {
      setError('يرجى اختيار الجزء المراد حجزه');
      return false;
    }
    
    if (!formData.appointment_time) {
      setError('يرجى اختيار الوقت');
      return false;
    }
    

   
    if (entityConfig.acceptMultipleUnit === 'yes' && selectedServices.length === 0) {
      setError('يرجى اختيار الخدمات المطلوبة');
      return false;
    }
    
    // Validate end time doesn't exceed closing time
    if (entityConfig.acceptMultipleUnit === 'yes') {
      const [timeHour, timeMin] = formData.appointment_time.split(':').map(Number);
      const startMinutes = timeHour * 60 + timeMin;
      const endMinutes = startMinutes + parseInt(formData.reservation_duration);
      
      const [endHour, endMin] = entityConfig.endTime.split(':').map(Number);
      const maxEndMinutes = endHour * 60 + endMin;
      
     // if (endMinutes > maxEndMinutes) 
      if (endMinutes-maxEndMinutes > 2 ) 
        {
        setError('وقت انتهاء الحجز يتجاوز وقت الإغلاق');
        return false;
      }
    }
    
 
      //   ********   ************   
  

      //   ********   ************

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validateBooking()) {
      return;
    }
    
    setSubmitting(true);
    
    try {
      var x=JSON.stringify({
            Entity_id: entityId,
            selectedServices: selectedServices,
            ...formData
          });
          console.log("what is sent");
          console.log(x);
          
      const token = localStorage.getItem('CustomerTokenA');
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/appointment/pay_visa_wallet`,
        {
          method: 'POST',
          headers: {
                     'Content-Type': 'application/json',
          'Accept': 'application/json' , // Add this`
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            Entity_id: Number(entityId)  ,
            selectedServices: selectedServices,
            ...formData
          })
        } 
      );
      
      const data = await response.json();
      
      if (response.ok) {
        if (onSuccess) {
         
          window.location.href = data.payment_link;

          //onSuccess(data);
          //setSubmitting(false);
          
        }
      } else {
        setError(data.message || 'حدث خطأ في الحجز');
      }
    } catch (err) {
      console.error('Error creating appointment:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
     // setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="flex-center p-8">
        <div className="spinner"></div>
        <p className="text-white mt-4">جاري التحميل...</p>
      </div>
    );
  }

  if (!entityConfig) {
    return (
      <div className="bg-red-500 bg-opacity-20 border border-red-500 rounded-lg p-4">
        <p className="text-white">فشل في تحميل بيانات الجهة</p>
      </div>
    );
  }

  const calculate_fees = (baseFee) => {
    // Placeholder for any complex fee calculation logic
    let xx= durationOptions[0];
    console.log("durationOptions[0]: ",xx);
    let yy= formData.reservation_duration;
    console.log("formData.reservation_duration: ",yy);
    let fee=0;
    let zz=Number(yy)/Number(xx);
    console.log("zz: ",zz);
    fee=Number(baseFee)*Number(zz);
    console.log("fee: ",fee);
    return fee;
     
  }

  const calculateTotalPrice = () => {
 
  let totalPrice = 0;
  selectedServices.forEach(serviceId => {
  const s = services.find(x => x.id.toString() === serviceId.toString());
  if (s) totalPrice += Number(s.price);
   });


  return totalPrice;
  };



  return (
    <div className="booking-form">
      <h2 className="text-white text-2xl font-bold mb-6">
        حجز جديد - {entityConfig.entityName}
      </h2>
      
      <form onSubmit={handleSubmit} className="flex-column gap-4">
        {/* 1. Date Selection */}
        <div>
          <label className="text-white block mb-2">التاريخ</label>
          <input
            type="date"
            name="appointment_date"
            value={formData.appointment_date}
            onChange={handleInputChange}
            min={new Date().toISOString().split('T')[0]}
            className="input"
            required
          />
        </div>

        {/* 2. Part Selection */}
        <div>
          <label className="text-white block mb-2">
            {entityConfig.acceptMultipleUnit === 'yes' ? 'الجزءالمراد حجزه' : 'الجزءالمراد حجزه'}
          </label>
          <select
            name="reserved_part"
            value={formData.reserved_part}
            onChange={handleInputChange}
            className="input"
            required
          >
            <option value="">اختر...</option>
            {entityConfig.parts && entityConfig.parts.map((part, index) => (
              <option key={index} value={part}>{part}</option>
            ))}
          </select>
        </div>

        {/* 3. Time/Period Selection */}
        {entityConfig.acceptMultipleUnit === 'yes' ? (
          // For Multiple Units (e.g., Sports Fields)
          <>
            <div>
              <label className="text-white block mb-2">ساعة الحجز</label>
              <select
                name="appointment_time"
                value={formData.appointment_time}
                onChange={handleInputChange}
                className="input"
                disabled={!formData.appointment_date || !formData.reserved_part}
                required
              >
                <option value="">اختر الساعة...</option>
                {availableSlots.map((slot, index) => (
                  <option key={index} value={slot}>{slot}</option>
                ))}
              </select>
              {availableSlots.length === 0 && formData.appointment_date && formData.reserved_part && (
                <p className="text-yellow-300 text-sm mt-1">لا توجد أوقات متاحة</p>
              )}
            </div>

            {/* Service Selection */}
            <div>
              <label className="text-white block mb-2">اختر الخدمات المطلوبة</label>
              <select
                multiple
                className="input"
                value={selectedServices}
                onChange={(e) => {
                  const vals = Array.from(e.target.selectedOptions, opt => opt.value);
                  setSelectedServices(vals);
                }}
                disabled={!formData.appointment_time}
              >
                {services.map((service, index) => (
                  <option key={index} value={service.id}>
                    {service.name} — {service.durationMinutes} دقيقة — {service.price} جنيه
                  </option>
                ))}
              </select>
            </div>

          </>
        ) : (
          // For Single Periods (e.g., Wedding Halls)
          <div>
            <label className="text-white block mb-2">فترة الحجز</label>
            <div className="flex-column gap-2">
              {availableSlots.map((period, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => handlePeriodSelect(period)}
                  className={`btn ${
                    formData.appointment_time === period.startTime
                      ? 'btn-primary'
                      : 'btn-secondary'
                  }`}
                  disabled={!formData.appointment_date || !formData.reserved_part}
                >
                  {period.label}
                </button>
              ))}
              {availableSlots.length === 0 && formData.appointment_date && formData.reserved_part && (
                <p className="text-yellow-300 text-sm">لا توجد فترات متاحة</p>
              )}
            </div>
          </div>
        )}

        {/* 4. Notes */}
        <div>
          <label className="text-white block mb-2">ملاحظات (اختياري)</label>
          <textarea
            name="notes"
            value={formData.notes}
            onChange={handleInputChange}
            className="input"
            rows="3"
            placeholder="أضف أي ملاحظات..."
          />
        </div>

        {/* Booking Summary */}
        {formData.appointment_time && (
          <div className="glass-dark p-4 rounded-lg">
            <h3 className="text-white font-bold mb-2">ملخص الحجز</h3>
            <div className="text-white text-sm space-y-1">
              <p>📅 التاريخ: {formData.appointment_date}</p>
              <p>📍 {entityConfig.acceptMultipleUnit === 'yes' ? 'المكان المراد حجزه' : 'المكان المراد حجزه'}: {formData.reserved_part}</p>
              <p>🕐 الوقت: {formData.appointment_time}</p>
          {selectedServices.length > 0 && (
          <p>
            🛠️ الخدمات المختارة:
            {selectedServices.map(id => {
              const s = services.find(x => x.id.toString() === id.toString());
              if (!s) return ''; // <-- prevents crashes
              return ` ${s.name} (${s.durationMinutes} دقيقة)، `;
            })}
          </p>
        )}


              {/* <p className="font-bold mt-2">💰 تكلفة جدية الحجز : {
               calculate_fees(entityConfig.reservationFee)
              } جنيه</p> */}

              <p className="font-bold mt-2">
              💰 تكلفة الخدمات: {calculateTotalPrice()} جنيه
              </p>

            </div>
          </div>
        )}

        {/* Error Display */}
        {error && (
          <div className="bg-red-500 bg-opacity-20 border border-red-500 rounded-lg p-3">
            <p className="text-white text-sm">{error}</p>
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex gap-4">
          <button
            type="submit"
            className="btn btn-primary flex-1"
            disabled={submitting}
          >
            {submitting ? (
              <div className="flex-center gap-2">
                <div className="spinner"></div>
                <span>جاري الحجز...</span>
              </div>
            ) : (
              'تأكيد الحجز'
            )}
          </button>
          
          <button
            type="button"
            onClick={onCancel}
            className="btn btn-secondary"
            disabled={submitting}
          >
            إلغاء
          </button>
        </div>
      </form>
    </div>
  );
};

export default BookingForm;